import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const requestedTransferVodafoneTariffQueryId = 'admin/vodafoneTariff/requestedTransfer';

export const RequestedTransferTab = () => {
  return (
    <VodafoneTariffTable
      queryId={requestedTransferVodafoneTariffQueryId}
      state={VodafoneTariffState.REQUESTED_TRANSFER}
      tabName="requested-transfer"
    />
  );
};
